import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "row h-xxl-100" }
const _hoisted_2 = { class: "col-12 col-xxl-7 chart-wrapper px-sm-2 px-md-4 pb-2_5 h-100" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col" }
const _hoisted_5 = {
  key: 0,
  class: "row mt-2"
}
const _hoisted_6 = { class: "col" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col" }
const _hoisted_9 = { class: "col-12 col-xxl-5 px-sm-2 px-md-4 mt-0 mt-xxl-2_5 h-100 mb-2_5" }
const _hoisted_10 = {
  key: 0,
  class: "row mt-2_5 mt-xxl-0"
}
const _hoisted_11 = { class: "col" }
const _hoisted_12 = {
  key: 1,
  class: "row row-cols-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _renderSlot(_ctx.$slots, "metric-title")
        ])
      ]),
      (_ctx.$slots.filterTabs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _renderSlot(_ctx.$slots, "filterTabs")
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _renderSlot(_ctx.$slots, "chart")
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_9, [
      (_ctx.$slots.summaryTitle)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _renderSlot(_ctx.$slots, "summaryTitle")
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.$slots.metricStats)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _renderSlot(_ctx.$slots, "metricStats")
          ]))
        : _createCommentVNode("", true),
      _renderSlot(_ctx.$slots, "metric-highlight")
    ])
  ]))
}